<section class="planGrid" aria-label="Available plans">
  @for (p of plans(); track p.id) {
    <app-plan-card
      [plan]="p"
      [disabled]="disabled()"
      (selected)="onSelected($event)"
    ></app-plan-card>
  }
</section>
<section class="planMeta">*All prices are exclusive of GST.</section>
